<template>
  <el-dialog
    class="course-detail"
    title="申请调课"
    :visible="addDialogShow"
    width="1000px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="选择班级">
        <el-cascader
          v-model="form.classNameVal"
          :placeholder="classPlaceholder"
          :props="classProps"
          :options="classSelect"
          @change="changeHandle"
        ></el-cascader>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" label-width="80px" :inline="true">
      <el-form-item label="原课程">
        <el-select
          v-model="form.originalCourse"
          placeholder="请选择原课程"
          @change="courseSelect"
        >
          <div
            slot="empty"
            style="
              padding: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #c0c4cc;
            "
          >
            <div>无课程数据</div>
          </div>
          <el-option
            v-for="item in arrangeListByTeacher"
            :key="item.itemDetail.id"
            :label="item.showContent"
            :value="item.itemDetail.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调课课程">
        <el-select
          v-model="form.transferCourse"
          placeholder="请选择调课课程"
          @change="classCourseSelect"
        >
          <div
            slot="empty"
            style="
              padding: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #c0c4cc;
            "
          >
            <div>无课程数据</div>
          </div>
          <el-option
            v-for="item in arrangeListByClass"
            :key="item.itemDetail.id"
            :label="item.showContentByClass"
            :value="item.itemDetail.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" label-width="80px" :inline="true">
      <el-form-item label="原周数">
        <el-radio-group v-model="form.originalWeek" size="mini">
          <el-radio-button
            v-for="(item, index) in weekList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="调课周数">
        <el-radio-group v-model="form.transferWeek" size="mini">
          <el-radio-button
            v-for="(item, index) in weekList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="调课原因">
        <el-select v-model="form.applyType" placeholder="请选择调课原因">
          <el-option
            v-for="item in dictTypeList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调课说明">
        <el-input type="textarea" v-model="form.reasonRemark"></el-input>
      </el-form-item>
      <el-button class="form-btn" type="primary" @click="onSubmit"
        >申请</el-button
      >
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: [
    "addDialogShow",
    "dictTypeList",
    "className",
    "classPlaceholder",
    "classProps",
    "classSelect",
    "classData",
  ],
  data() {
    return {
      form: {
        originalCourse: "",
        transferCourse: "",
        applyType: "",
        reasonRemark: "",
        arrangeByTeacher: null,
        arrangeByClass: null,
        originalWeek: "",
        transferWeek: "",
        classNameVal: "",
      },
      arrangeListByClass: [],
      arrangeListByTeacher: [],
      weekList: [
        {
          label: "1",
          value: 1,
        },
        {
          label: "2",
          value: 2,
        },
        {
          label: "3",
          value: 3,
        },
        {
          label: "4",
          value: 4,
        },
        {
          label: "5",
          value: 5,
        },
        {
          label: "6",
          value: 6,
        },
        {
          label: "7",
          value: 7,
        },
        {
          label: "8",
          value: 8,
        },
        {
          label: "9",
          value: 9,
        },
        {
          label: "10",
          value: 10,
        },
        {
          label: "11",
          value: 11,
        },
        {
          label: "12",
          value: 12,
        },
        {
          label: "13",
          value: 13,
        },
        {
          label: "14",
          value: 14,
        },
        {
          label: "15",
          value: 15,
        },
        {
          label: "16",
          value: 16,
        },
        {
          label: "17",
          value: 17,
        },
        {
          label: "18",
          value: 18,
        },
        {
          label: "19",
          value: 19,
        },
        {
          label: "20",
          value: 20,
        },
      ],
      selectClassData: [],
    };
  },
  mounted() {
    // console.log("add-arrangeListByTeacher==>", this.arrangeListByTeacher);
    this.selectClassData = this.classData;
    this.selectCourseArrangeByTeacherClassId();
  },
  methods: {
    // 选择班级
    changeHandle(e) {
      this.selectClassData.classId = e[1].classId;
      this.selectClassData.className = e[1].className;
      this.form.originalCourse = "";
      this.form.transferCourse = "";
      this.selectCourseArrangeByTeacherClassId();
    },
    dialogOpen() {
      this.form = {
        originalCourse: "",
        transferCourse: "",
        applyType: "",
        reasonRemark: "",
        arrangeByTeacher: null,
        arrangeByClass: null,
      };
      this.arrangeListByClass = [];
      // console.log("班级arrangeListByClass==>", this.arrangeListByClass);
      // console.log("教师arrangeListByTeacher==>", this.arrangeListByTeacher);
      // console.log("调课原因dictTypeList==>", this.dictTypeList);
    },
    dialogClose() {
      this.$emit("update:addDialogShow", false);
    },
    courseSelect(e) {
      // this.form.arrangeByTeacher = item;
      // this.selectCourseArrangeApplyForByClass(id);
    },
    classCourseSelect(item) {
      // this.form.arrangeByClass = item;
    },
    selectCourseArrangeByTeacherClassId() {
      this.get(
        this.$url.selectCourseArrangeByTeacherClassId +
          "?classId=" +
          this.selectClassData.classId
      ).then((res) => {
        // console.log("查询教师带教班级课程信息和可调课程信息==>", res);
        let data = res.data;
        this.arrangeListByTeacher = this.returnCoursesAvailable(
          data.teachingSubjectInfo
        );
        this.arrangeListByClass = this.returnCoursesAvailable(
          data.notTeachingSubjectInfo
        );
        // console.log("this.arrangeListByTeacher==>", this.arrangeListByTeacher);
        // console.log("this.arrangeListByClass==>", this.arrangeListByClass);
      });
    },
    returnCoursesAvailable(data) {
      let list = [];
      // 使用 forEach() 遍历数据中的每个对象
      data.forEach((item) => {
        var courseDetails = item.courseDetails;

        courseDetails.forEach((itemDetail) => {
          // 判断 itemDetail 中的 courseName 是否为非空值
          if (itemDetail.courseName !== null) {
            itemDetail["classPeriod"] = item.name;
            itemDetail["weekVal"] = this.getDayName(itemDetail.week);
            // 创建新对象并添加 startTime、endTime 和 lessons
            var newObj = {
              startTime: item.startTime,
              endTime: item.endTime,
              lessons: item.lessons,
              showContent:
                itemDetail.courseName +
                "__" +
                "星期" +
                itemDetail.week +
                "__" +
                item.name,
              showContentByClass:
                itemDetail.courseName +
                "__" +
                "星期" +
                itemDetail.week +
                "__" +
                item.name +
                "__" +
                itemDetail.teacherName,
              itemDetail,
            };

            // 将满足条件的对象添加到 arrangeList 数组中
            list.push(newObj);
          }
        });
      });
      return list;
    },
    getDayName(dayNumber) {
      switch (dayNumber) {
        case 1:
          return "星期一";
        case 2:
          return "星期二";
        case 3:
          return "星期三";
        case 4:
          return "星期四";
        case 5:
          return "星期五";
        case 6:
          return "星期六";
        case 7:
          return "星期日";
        default:
          return "无效的星期";
      }
    },
    onSubmit() {
      this.form.arrangeByTeacher = this.arrangeListByTeacher.find((item) => {
        return item.itemDetail.id === this.form.originalCourse;
      });
      this.form.arrangeByClass = this.arrangeListByClass.find((item) => {
        return item.itemDetail.id === this.form.transferCourse;
      });
      // console.log(this.form);
      let arrTeacherDetail = this.form.arrangeByTeacher.itemDetail;
      let arrClassDetail = this.form.arrangeByClass.itemDetail;
      // console.log("arrTeacherDetail==>", arrTeacherDetail, arrClassDetail);

      this.post(this.$url.addTeacherApplyFor, {
        schoolId: this.user.schoolId,
        applyTeacherId: arrTeacherDetail.teacherId,
        applyTeacherName: arrTeacherDetail.teacherName,
        applyType: this.form.applyType,
        reason: this.form.applyType,
        reasonRemark: this.form.reasonRemark,
        dataList: [
          {
            courseArrangeId: arrTeacherDetail.id,
            courseArrangeName: arrTeacherDetail.courseName,
            // courseArrangeWeek: this.form.originalWeek,
            exchangeTeacherId: arrClassDetail.teacherId,
            exchangeTeacherName: arrClassDetail.teacherName,
            exchangeCourseArrangeId: arrClassDetail.id,
            exchangeCourseArrangeName: arrClassDetail.courseName,
            // exchangeCourseArrangeWeek: this.form.transferWeek,
            courseArrangeWeek: arrTeacherDetail.weekVal,
            courseArrangeCycle: this.form.originalWeek,
            courseArrangeLessons: arrTeacherDetail.classPeriod,
            exchangeCourseArrangeWeek: arrClassDetail.weekVal,
            exchangeCourseArrangeCycle: this.form.transferWeek,
            exchangeCourseArrangeLessons: arrClassDetail.classPeriod,
          },
        ],
      }).then((res) => {
        // console.log("新增调课返回==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success("新增成功");
        // 刷新列表
        this.$emit("addTeacherApplyFor");
        // 关闭弹出框
        this.dialogClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseAdjustmentAdd.scss";
</style>
